type LogLevel = 'info' | 'warn' | 'error' | 'debug';

export interface StructuredLog {
  level: LogLevel;
  message: string;
  meta?: Record<string, unknown>;
  timestamp: string;
}

const isDebugEnabled = (): boolean => {
  if (typeof import.meta !== 'undefined' && (import.meta as unknown as { env?: { DEV?: boolean } }).env?.DEV) {
    return true;
  }
  if (typeof process !== 'undefined' && typeof process.env !== 'undefined') {
    return process.env.ENABLE_DEBUG_LOGGING === 'true';
  }
  return false;
};

const emit = (level: LogLevel, message: string, meta?: Record<string, unknown>): StructuredLog => {
  const entry: StructuredLog = {
    level,
    message,
    meta,
    timestamp: new Date().toISOString()
  };

  const payload = JSON.stringify(entry);
  switch (level) {
    case 'info':
      console.log(payload);
      break;
    case 'warn':
      console.warn(payload);
      break;
    case 'error':
      console.error(payload);
      break;
    case 'debug':
    default:
      if (isDebugEnabled()) {
        console.debug(payload);
      }
      break;
  }

  return entry;
};

export const structuredLogger = {
  info: (message: string, meta?: Record<string, unknown>): StructuredLog => emit('info', message, meta),
  warn: (message: string, meta?: Record<string, unknown>): StructuredLog => emit('warn', message, meta),
  error: (message: string, meta?: Record<string, unknown>): StructuredLog => emit('error', message, meta),
  debug: (message: string, meta?: Record<string, unknown>): StructuredLog => emit('debug', message, meta)
};

